// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Ge2","toggle":"styles_toggle__3TJHA","preview":"styles_preview__1jkdj"};